// Reserved URL params - not filter criteria (pagination, search, view flags)
const RESERVED_PARAMS = ["page", "search", "limit", "groupBy"];

const VALID_GROUP_BY = new Set([
  "accounts",
  "industry",
  "campaigns",
  "match_fit",
]);

const ARRAY_FILTER_KEYS = new Set([
  "company",
  "designation",
  "matchScoreFit",
  "industry",
  "country",
  "companySize",
  "enrollmentStatus",
  "dateCreated",
  "targetIndustries",
  "employees",
]);

export const parseFiltersFromURL = (searchParams) => {
  const filters = {};

  for (const [key, value] of searchParams.entries()) {
    if (!value || RESERVED_PARAMS.includes(key)) continue;

    if (ARRAY_FILTER_KEYS.has(key)) {
      filters[key] = value.split(",").map((s) => s.trim()).filter(Boolean);
    } else if (value.includes(",")) {
      filters[key] = value.split(",");
    } else {
      filters[key] = value;
    }
  }

  return filters;
};

/** @returns {"accounts" | "industry" | "campaigns" | "match_fit" | null} */
export const parseGroupByFromURL = (searchParams) => {
  const v = searchParams.get("groupBy");
  if (v && VALID_GROUP_BY.has(v)) return v;
  return null;
};

export const buildURLFromFilters = ({
  filters = {},
  searchValue,
  page,
  groupBy = null,
}) => {
  const params = new URLSearchParams();

  if (searchValue) params.set("search", searchValue);
  if (page) params.set("page", String(page));

  if (groupBy && VALID_GROUP_BY.has(groupBy)) {
    params.set("groupBy", groupBy);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (RESERVED_PARAMS.includes(key)) return;
    if (Array.isArray(value) && value.length > 0) {
      params.set(key, value.join(","));
    } else if (typeof value === "string" && value.trim()) {
      params.set(key, value.trim());
    }
  });

  return params.toString();
};
